import React, { Component } from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  DirectionsRenderer,
  Polyline,
} from "react-google-maps";
// import Geocode from "react-geocode";
let directionsService;
var thisContex;
// To use the Google Maps JavaScript API, you must register your app project on the Google API Console and get a Google API key which you can add to your app
const apiKey = "AIzaSyBGIZnChXdkuvH5689--pSdpuOTydVWqMg";

const GoogleMapsComponent = withScriptjs(
  withGoogleMap((props) => {
    console.log(props);
    return (
      <GoogleMap
        onLoad={(map) => this.changeDirection()}
        defaultZoom={13}
        defaultCenter={{ lat: props.lat[0], lng: props.lng[0] }}
      >
        {<Marker position={{ lat: props.lat[0], lng: props.lng[0] }} />}
        {<Marker position={{ lat: props.lat[1], lng: props.lng[1] }} />}
        <Polyline
          strokeWidth={5}
          geodesic={true}
          strokeColor="rgba(0,0,200,0.5)"
          lineDashPattern={[47.12]}
          path={[
            { lat: props.lat[0], lng: props.lng[0] },
            { lat: props.lat[1], lng: props.lng[1] },
          ]}
        />
        {thisContex.state.directions !== null && (
          <DirectionsRenderer directions={thisContex.state.directions} />
        )}
      </GoogleMap>
    );
  })
);

class ReactGoogleMaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directions: null,
      bounds: null,
    };
    thisContex = this;
  }

  changeDirection = () => {
    directionsService = new window.google.maps.DirectionsService();
    let origin = { lat: this.props.lat[0], lng: this.props.lng[0] };
    let destination = { lat: this.props.lat[1], lng: this.props.lng[1] };
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          //changing the state of directions to the result of direction service
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  };

  render() {
    var getLat = [];
    getLat.push(this.props.lat);
    getLat.push(this.props.lat2);
    var getLng = [];
    getLng.push(this.props.lng);
    getLng.push(this.props.lng2);

    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <i className="icon-map"></i> Google Maps
            {/* <a href="https://coreui.io/pro/react/" className="badge badge-danger">CoreUI Pro Component</a>
          <div className="card-header-actions"> 
             <a href="https://github.com/tomchentw/react-google-maps" rel="noreferrer noopener" target="_blank" className="card-header-action">
              <small className="text-muted">docs</small>
            </a> 
          </div>*/}
          </CardHeader>
          <CardBody>
            <GoogleMapsComponent
              key="map"
              googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${apiKey}`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `800px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
              lat={getLat}
              lng={getLng}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ReactGoogleMaps;

// function initMap() {
//   var directionsService = new google.maps.DirectionsService();
//   var directionsRenderer = new google.maps.DirectionsRenderer();
//   var chicago = new google.maps.LatLng(41.850033, -87.6500523);
//   var mapOptions = {
//     zoom:7,
//     center: chicago
//   }
//   var map = new google.maps.Map(document.getElementById('map'), mapOptions);
//   directionsRenderer.setMap(map);
// }

// function calcRoute() {
//   var start = document.getElementById('start').value;
//   var end = document.getElementById('end').value;
//   var request = {
//     origin: start,
//     destination: end,
//     travelMode: 'DRIVING'
//   };
//   directionsService.route(request, function(result, status) {
//     if (status == 'OK') {
//       directionsRenderer.setDirections(result);
//     }
//   });
// }
